import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Login from "../Routes/Login/index";
import FeeTaxForm from "../Routes/FeeTaxForm/index";
import DonationTaxForm from "../Routes/DonationTaxForm/index";

const LoggedOutRoutes = () => (
  <Switch>
    {/* 회비 주민번호 수집 공개 폼 (비로그인) */}
    <Route exact path="/fee-tax-info/:token" component={FeeTaxForm} />
    {/* 기부 주민번호 수집 공개 폼 (비로그인) */}
    <Route
      exact
      path="/donation-tax-info/:token"
      component={DonationTaxForm}
    />
    <Route exact Path="/login" component={Login} />
    <Redirect from="*" to="/" />
  </Switch>
);

export default LoggedOutRoutes;
